import {Injectable} from '@angular/core';
import {Forecast} from '../forecast/forecast';
import {Observable} from 'rxjs';
import {ForecastRevisionCollection} from './forecast-revision-collection';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import * as classTransformer from 'class-transformer';
import {ForecastRevision} from './forecast-revision';
import {formatDate} from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class ForecastRevisionService {

    constructor(private httpClient: HttpClient) {
    }

    public getRevisions(forecast: Forecast): Observable<ForecastRevisionCollection> {
        return this.httpClient
            .get('/forecasts/' + forecast.id + '/revisions')
            .pipe(map((result: any) => {
                const collection = new ForecastRevisionCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setForecastRevisions(
                    result['member'].map((revisionData: any) => classTransformer.plainToInstance(ForecastRevision, revisionData))
                );

                return collection;
            }));
    }

    public createForecastRevision(forecast: Forecast, revisedQuantity: number): Observable<any> {
        const body = {
            forecast: forecast.id,
            quantity: revisedQuantity
        };

        return this.httpClient.post('/revise-forecast', body);
    }
}
